import { createPreferenceManager } from './lib/manager'

const preferences = {
  darkMode: 'auto' as 'on' | 'off' | 'auto',
}

export type Preferences = typeof preferences

export const { setPreference, getPreference, onPreferenceChange } = createPreferenceManager(preferences)
